import { formatResponse, get, getApiEndpoint, transformApiUrl } from '../helpers/index.js';

class ParcelService {
  constructor(client) {
    this.client = client;
    this.apiEndpoint = getApiEndpoint()+'parcel';
  }

  async all() {
    const action = 'read';
    this.apiEndpoint = transformApiUrl(this.apiEndpoint);
    const endpoint = `${this.apiEndpoint}/${action}`;
    const getResponse = await get(this.client, endpoint, {
      params: { id: '' },
    });
    return formatResponse(getResponse);
  }

  async findById(id) {
    const action = 'read';
    this.apiEndpoint = transformApiUrl(this.apiEndpoint);
    const endpoint = `${this.apiEndpoint}/${action}`;
    const getResponse = await get(this.client, endpoint, {
      params: { id },
    });
    const [parcel] = formatResponse(getResponse);
    return parcel;
  }
}

export { ParcelService as default };
